/**
 * PostHog + Meta Pixel Event Tracking — Serenity Dawn Active
 *
 * E-commerce:  product_viewed, add_to_cart, checkout_started, order_completed
 * Atribución:  Variable Stack (VSID de utm_content → ad_hook/ad_angle/… super-props)
 * Funnel COD:  cod_form_opened, cod_field_focused/completed, cod_*_selected,
 *              cod_phone_captured, cod_submit_clicked, cod_form_abandoned
 * Landing:     faq_opened, offer_selected, gallery_image_viewed, video_progress,
 *              video_slide_viewed, sticky_cta_shown/clicked, ingredients_dropdown_opened
 * KPIs CRO:    section_viewed, section_dwell, first_content_engaged, page_exit,
 *              scroll_depth_reached, animation_engaged, image_clicked
 * Experimentos: applyFlagVariants() aplica variantes de copy/disparador por feature flag
 *
 * Meta Pixel:  ViewContent, AddToCart, InitiateCheckout, Lead, SubmitApplication
 *              — sincronizados con PostHog via meta_event_id (dedup CAPI).
 *              Purchase NO se dispara aquí (lo hace el canal nativo FB/IG → evita doble-conteo).
 *
 * Design system del tema live: sl-* (secciones .sl-sec/.sl-hero, FAQ .sl-faq__item,
 * oferta .sl-btn--offer[data-srn-qty], galería .sl-gallery__img, videos .srn-rv__video).
 */

/* ── GUARD DE CAPTURA (2026-08-26) ─────────────────────────────────────────────
   PROBLEMA OBSERVADO EN PRODUCCION: "TypeError: posthog.capture is not a function".
   El init de PostHog vive en snippets/serenity-tracking.liquid dentro de un
   requestIdleCallback, y este archivo carga con defer y llama posthog.capture()
   directo en 40+ sitios SIN verificar. Cuando el evento gana la carrera:
     1) el evento se PIERDE — incluido product_viewed, que es el denominador
        de todo el funnel (o sea, las tasas de conversion salen infladas), y
     2) el TypeError ABORTA el resto de esa funcion.
   Mismo tipo de fallo que dejo el tracking muerto 3 dias en julio 2026.

   FIX: si capture aun no existe, se instala un stub que ENCOLA. Cuando PostHog
   termina de cargar, se vacia la cola en orden. Peor caso = lo mismo que hoy
   (se pierden), nunca peor. */
(function () {
  var W = window, Q = [];
  function stub() { Q.push(Array.prototype.slice.call(arguments)); }
  function listo() {
    return W.posthog && typeof W.posthog.capture === 'function' && W.posthog.capture !== stub;
  }
  if (listo()) return;
  if (!W.posthog) W.posthog = {};
  if (typeof W.posthog.capture !== 'function') W.posthog.capture = stub;
  var t0 = Date.now();
  var iv = setInterval(function () {
    if (listo()) {
      clearInterval(iv);
      var pendientes = Q.splice(0, Q.length);
      for (var i = 0; i < pendientes.length; i++) {
        try { W.posthog.capture.apply(W.posthog, pendientes[i]); } catch (e) {}
      }
    } else if (Date.now() - t0 > 15000) {
      clearInterval(iv);   /* PostHog nunca cargo: soltar la cola, no crecer sin limite */
      Q.length = 0;
    }
  }, 120);
})();


(function () {
  if (typeof window.posthog === 'undefined') return;

  // ── Shared context ─────────────────────────────────────────────────────────
  const template = document.querySelector('#MainContent')?.dataset?.template || '';
  const pageUrl  = window.location.href;
  const pagePath = window.location.pathname;
  const idle     = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  // ── Variable Stack — atribución del ad (VSID → super/person props) ──────────
  // Meta pone el VSID en utm_content (p.ej. h03a01p02s01v01c02l01). Lo parseamos
  // a super-props que viajan en TODOS los eventos que dispara este archivo, más
  // person-props de first-touch. Así el funnel on-page se corta por hook/ángulo/
  // persona/etc igual que las variantes en Meta. Sin VSID → no registra nada.
  try {
    const vsq = new URLSearchParams(window.location.search);
    const vsMap = { h: 'ad_hook', a: 'ad_angle', p: 'ad_persona', s: 'ad_show', v: 'ad_voice', c: 'ad_clip', l: 'ad_landing' };
    const vsName = vsq.get('utm_content') || '';
    const vsStack = {};
    (vsName.match(/[hapsvcl]\d{2}/g) || []).forEach((t) => { vsStack[vsMap[t[0]]] = t.slice(1); });
    const vsAdId = vsq.get('ad_id') || null;
    const vsCampaign = vsq.get('utm_campaign') || null;
    if (vsAdId || vsName || Object.keys(vsStack).length) {
      posthog.register({ ad_id: vsAdId, ad_name: vsName || null, utm_campaign: vsCampaign, ...vsStack });
      posthog.setPersonProperties(vsStack, { first_ad_id: vsAdId, first_ad_name: vsName || null });
    }
  } catch (e) {}

  // ── Meta Pixel helpers ─────────────────────────────────────────────────────
  // Generates a unique event ID for CAPI deduplication (browser + server same ID)
  function genEventId() {
    return 'ev_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
  }

  // Fires a Meta Pixel event safely, ignoring if fbq is blocked
  function fbTrack(eventName, params, eventId) {
    try {
      if (typeof window.fbq !== 'function') return;
      window.fbq('track', eventName, params, { eventID: eventId });
    } catch (e) {}
  }

  // Etiqueta legible de una sección. Prioriza el modificador sl-* del tema
  // (sl-sec sl-faq → "faq", sl-hero → "hero"), luego data-attrs / id.
  const SL_SKIP = new Set(['sl-sec', 'sl-modular', 'sl-wrap', 'sl-reveal']);
  function sectionLabel(el) {
    const slc = (el.className || '').split(/\s+/).find(
      (c) => c.startsWith('sl-') && !SL_SKIP.has(c) && !c.includes('__')
    );
    if (slc) return slc.replace('sl-', '');
    return (
      el.dataset.sectionId ||
      el.dataset.section ||
      el.id ||
      el.dataset.componentName ||
      el.getAttribute('aria-label') ||
      (el.className || '').split(' ').find((c) => c.length > 3 && !c.includes('shopify')) ||
      'unknown'
    );
  }

  function nearestSection(el) {
    return el?.closest('.sl-sec, .sl-hero, [data-section-id], section, [id]') || null;
  }

  // ── Product Viewed → Meta ViewContent ─────────────────────────────────────
  if (template.startsWith('product')) {
    const productData = window.ShopifyAnalytics?.meta?.product;
    if (productData) {
      const eventId = genEventId();
      const price   = productData.variants?.[0]?.price / 100;
      const currency = window.Shopify?.currency?.active || 'USD';

      posthog.capture('product_viewed', {
        product_id:     productData.id,
        product_name:   productData.title,
        product_type:   productData.type,
        product_vendor: productData.vendor,
        price,
        currency,
        url:            pageUrl,
        meta_event_id:  eventId,
      });

      fbTrack('ViewContent', {
        content_ids:  [String(productData.id)],
        content_name: productData.title,
        content_type: 'product',
        value:        price,
        currency,
      }, eventId);
    }
  }

  // ── Add to Cart → Meta AddToCart ───────────────────────────────────────────
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource?.url || '';

    if (url.includes('/cart/add')) {
      try {
        const body = config?.body;
        let items = [];

        if (typeof body === 'string') {
          try {
            const parsed = JSON.parse(body);
            items = parsed.items || (parsed.id ? [parsed] : []);
          } catch {
            const params = new URLSearchParams(body);
            if (params.get('id')) {
              items = [{ id: params.get('id'), quantity: params.get('quantity') || 1 }];
            }
          }
        } else if (body instanceof FormData) {
          if (body.get('id')) {
            items = [{ id: body.get('id'), quantity: body.get('quantity') || 1 }];
          }
        }

        const response = await originalFetch.apply(this, args);
        response.clone().json().then((data) => {
          const addedItems = data.items || (data.id ? [data] : items);
          if (addedItems.length) window.__agAddedToCart = true;
          addedItems.forEach((item) => {
            const eventId  = genEventId();
            const price    = (item.price || item.final_price || 0) / 100;
            const currency = window.Shopify?.currency?.active || 'USD';

            posthog.capture('add_to_cart', {
              product_id:    item.product_id || item.id,
              variant_id:    item.variant_id || item.id,
              product_name:  item.product_title || item.title,
              variant_name:  item.variant_title,
              price,
              quantity:      item.quantity || 1,
              currency,
              sku:           item.sku,
              meta_event_id: eventId,
            });

            fbTrack('AddToCart', {
              content_ids:  [String(item.product_id || item.id)],
              content_name: item.product_title || item.title,
              content_type: 'product',
              value:        price * (item.quantity || 1),
              currency,
            }, eventId);
          });
        }).catch(() => {});
        return response;
      } catch {
        return originalFetch.apply(this, args);
      }
    }

    return originalFetch.apply(this, args);
  };

  // ── Checkout Started → Meta InitiateCheckout ───────────────────────────────
  document.addEventListener('click', function (e) {
    const el = e.target.closest('[href*="/checkout"], [name="checkout"], [data-action="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
    if (!el) return;

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const eventId  = genEventId();
        const currency = cart.currency;
        const value    = cart.total_price / 100;

        posthog.capture('checkout_started', {
          cart_total:    value,
          item_count:    cart.item_count,
          currency,
          meta_event_id: eventId,
          items: (cart.items || []).map((item) => ({
            product_id:   item.product_id,
            variant_id:   item.variant_id,
            product_name: item.product_title,
            variant_name: item.variant_title,
            price:        item.price / 100,
            quantity:     item.quantity,
            sku:          item.sku,
          })),
        });

        fbTrack('InitiateCheckout', {
          content_ids: (cart.items || []).map((i) => String(i.product_id)),
          num_items:   cart.item_count,
          value,
          currency,
        }, eventId);
      })
      .catch(() => {});
  }, true);

  // ── Order Completed → Meta Purchase ───────────────────────────────────────
  if (window.Shopify?.checkout) {
    const checkout = window.Shopify.checkout;
    const eventId  = genEventId();
    const revenue  = parseFloat(checkout.total_price);
    const currency = checkout.currency;

    posthog.capture('order_completed', {
      order_id:      checkout.order_id,
      order_number:  checkout.order_number,
      revenue,
      subtotal:      parseFloat(checkout.subtotal_price),
      shipping:      parseFloat(checkout.shipping_rate?.price || 0),
      tax:           parseFloat(checkout.tax_price),
      currency,
      email:         checkout.email,
      meta_event_id: eventId,
      items: (checkout.line_items || []).map((item) => ({
        product_id:   item.product_id,
        variant_id:   item.variant_id,
        product_name: item.title,
        price:        parseFloat(item.price),
        quantity:     item.quantity,
        sku:          item.sku,
      })),
    });

    // Meta Purchase lo dispara el canal nativo Facebook & Instagram de Shopify.
    // NO fbTrack('Purchase') aquí — duplicaba el evento (incidente 2026-05-13).
  }

  // ── Search Submitted ───────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    const q = form.querySelector('[name="q"]')?.value;
    if (q) posthog.capture('search_submitted', { query: q, page_path: pagePath });
  });

  // ── Button Clicked ─────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      'button, [role="button"], input[type="submit"], input[type="button"]'
    );
    if (!btn) return;

    const skipPatterns = [/checkout/i, /add.?to.?cart/i];
    const rawText = (
      btn.textContent ||
      btn.value ||
      btn.getAttribute('aria-label') ||
      btn.getAttribute('title') ||
      ''
    ).trim();

    if (!rawText || skipPatterns.some((p) => p.test(rawText))) return;

    const section = nearestSection(btn);
    posthog.capture('button_clicked', {
      button_text:   rawText.slice(0, 100),
      button_id:     btn.id || null,
      button_type:   btn.type || btn.getAttribute('role') || null,
      section:       section ? sectionLabel(section) : null,
      page_path:     pagePath,
      page_template: template,
    });
  });

  // ── CTA Clicked ────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const cta = e.target.closest('a[href], .sl-btn, .sl-sticky__cta');
    if (!cta) return;

    const href = cta.href || '';
    const text = (cta.textContent || cta.getAttribute('aria-label') || '').trim();
    const isBtn = cta.matches('.sl-btn, .sl-sticky__cta');
    const isInternalNav = href.includes(window.location.hostname) || href.startsWith('/');

    if (!isBtn && (!isInternalNav || !text)) return;

    const ctaPatterns = /compra|buy|shop|order|get|start|try|ver|view|add|subscribe|join|learn|more|ahora|now|producto|product|pedir|quiero|dormir/i;
    if (!isBtn && !ctaPatterns.test(text) && !ctaPatterns.test(href)) return;

    const section = nearestSection(cta);
    posthog.capture('cta_clicked', {
      cta_text:      text.slice(0, 100),
      cta_url:       href || null,
      cta_id:        cta.id || cta.dataset.cta || null,
      cta_section:   section ? sectionLabel(section) : null,
      page_path:     pagePath,
      page_template: template,
    });
  });

  // ── Form Submitted ─────────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.action?.includes('/search')) return;

    const sensitiveFields = /password|card|cvv|ssn|secret/i;
    const fields = Array.from(form.elements)
      .filter((el) => el.name && !sensitiveFields.test(el.name) && el.type !== 'hidden')
      .map((el) => el.name);

    posthog.capture('form_submitted', {
      form_id:       form.id || null,
      form_action:   form.action || null,
      form_method:   form.method || 'get',
      field_names:   fields,
      page_path:     pagePath,
      page_template: template,
    });
  });

  // ── Scroll Depth → Meta también a 75% ─────────────────────────────────────
  const scrollMilestones = [10, 25, 50, 75, 100]; // 10 = "primer scroll" (2026-09-26): mide el rebote exacto del hero
  const firedMilestones  = new Set();
  let   maxScrollPct     = 0;

  function getScrollDepth() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    return docHeight <= 0 ? 100 : Math.round((scrollTop / docHeight) * 100);
  }

  function onScroll() {
    const depth = getScrollDepth();
    if (depth > maxScrollPct) maxScrollPct = depth;
    scrollMilestones.forEach((milestone) => {
      if (depth >= milestone && !firedMilestones.has(milestone)) {
        firedMilestones.add(milestone);

        posthog.capture('scroll_depth_reached', {
          depth_percent:  milestone,
          page_path:      pagePath,
          page_template:  template,
        });

        // Meta: custom event a 75% — intención alta. Usa trackCustom (no 'track',
        // que exige un nombre de evento estándar y tiraba un warning en consola).
        if (milestone === 75) {
          try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'PageScrolled75', { page_path: pagePath }); } catch (e) {}
        }

        if (firedMilestones.size === scrollMilestones.length) {
          window.removeEventListener('scroll', onScroll, { passive: true });
        }
      }
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── Section Viewed + Section Dwell ────────────────────────────────────────
  // section_viewed: 1ª vez que una sección entra ≥50%. section_dwell: al SALIR
  // de vista, cuánto tiempo estuvo visible (proxy de "qué copy retiene atención").
  const SECTION_SELECTOR = '.sl-sec, .sl-hero, [data-section-id], section';
  const viewedSections = new Set();
  const dwellState = new WeakMap(); // el → { enteredAt, label }
  let   lastSectionInView = null;

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el    = entry.target;
        const label = sectionLabel(el);

        if (entry.isIntersecting) {
          lastSectionInView = label;
          if (!dwellState.has(el)) dwellState.set(el, { enteredAt: performance.now(), label });

          if (!viewedSections.has(label)) {
            viewedSections.add(label);
            posthog.capture('section_viewed', {
              section_name:  label,
              section_index: Array.from(document.querySelectorAll(SECTION_SELECTOR)).indexOf(el),
              page_path:     pagePath,
              page_template: template,
            });
          }
        } else {
          const st = dwellState.get(el);
          if (st) {
            const dwellMs = Math.round(performance.now() - st.enteredAt);
            dwellState.delete(el);
            // Ignora parpadeos <400ms (scroll rápido de paso).
            if (dwellMs >= 400) {
              posthog.capture('section_dwell', {
                section_name:  label,
                dwell_ms:      dwellMs,
                page_path:     pagePath,
                page_template: template,
              });
            }
          }
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll(SECTION_SELECTOR).forEach((el) => sectionObserver.observe(el));

  // section_viewed del HERO al cargar (2026-09-26): con threshold 0.5 un hero más alto
  // que la pantalla nunca llegaba al 50% → solo 109 de 376 sesiones lo registraban.
  // El hero está en pantalla desde el primer frame; se marca con on_load:true.
  (function () {
    const hero = document.querySelector('.sl-hero');
    if (!hero) return;
    const label = sectionLabel(hero);
    if (viewedSections.has(label)) return;
    viewedSections.add(label);
    lastSectionInView = lastSectionInView || label;
    posthog.capture('section_viewed', {
      section_name:  label,
      section_index: Array.from(document.querySelectorAll(SECTION_SELECTOR)).indexOf(hero),
      on_load:       true,
      page_path:     pagePath,
      page_template: template,
    });
  })();

  // ── Animation Engaged ──────────────────────────────────────────────────────
  const animationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const label =
          el.dataset.animationName ||
          el.dataset.animation ||
          el.id ||
          (el.className || '').split(' ').find((c) => c.includes('anim') || c.includes('fade') || c.includes('slide') || c.includes('reveal')) ||
          'animated_element';

        posthog.capture('animation_engaged', {
          animation_name: label,
          section:        sectionLabel(nearestSection(el) || el),
          page_path:      pagePath,
          page_template:  template,
        });
        animationObserver.unobserve(el);
      });
    },
    { threshold: 0.3 }
  );

  document.querySelectorAll(
    '[data-animation], [data-animate], .animate, .fade-in, .slide-in, .sl-reveal, ' +
    '[class*="anim"], [class*="fade"], [class*="slide-"], [class*="reveal"]'
  ).forEach((el) => animationObserver.observe(el));

  // ── Image Clicked ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const img = e.target.closest('img, picture, [role="img"]');
    if (!img) return;
    if (img.width < 60 || img.height < 60) return;

    const src     = img.src || img.currentSrc || img.dataset.src || '';
    const section = nearestSection(img);

    posthog.capture('image_clicked', {
      image_src:     src.split('?')[0].split('/').pop(),
      image_alt:     img.alt || null,
      image_width:   img.naturalWidth || img.width,
      section:       section ? sectionLabel(section) : null,
      page_path:     pagePath,
      page_template: template,
    });
  });

  // ── Outbound Link Clicked ──────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.href || '';
    const isOutbound =
      href.startsWith('http') &&
      !href.includes(window.location.hostname) &&
      !href.startsWith('javascript');

    if (!isOutbound) return;

    posthog.capture('outbound_link_clicked', {
      link_url:      href,
      link_text:     (link.textContent || link.getAttribute('aria-label') || '').trim().slice(0, 100),
      link_domain:   new URL(href).hostname,
      page_path:     pagePath,
      page_template: template,
    });
  });

  // ══════════════════════════════════════════════════════════════════════════
  //  FUNNEL COD (EasySell) — el corazón de la conversión en estas landings
  // ══════════════════════════════════════════════════════════════════════════
  // El "submit" de EasySell hace window.location → wa.me (sin submit del DOM),
  // así que enganchamos el ciclo a mano: apertura (MutationObserver), campos,
  // submit (capture phase + sendBeacon para sobrevivir el redirect), abandono.
  if (template.startsWith('product')) {
    const COD_FIELD_SELECTORS = {
      nombre:      'input[name*="first" i], input[name*="nombre" i], input[placeholder*="Nombre" i]:not([placeholder*="Apellido" i])',
      apellido:    'input[name*="last" i], input[name*="apellido" i], input[placeholder*="Apellido" i]',
      celular:     'input[name*="phone" i], input[type="tel"], input[name*="celular" i]',
      direccion:   'input[name*="address" i], input[name*="direccion" i], input[placeholder*="Direcci" i]',
      referencias: 'input[name*="ref" i], textarea[name*="ref" i], input[placeholder*="Referencia" i]',
      provincia:   'select[name*="province" i], select[name*="provincia" i], select[name*="state" i]',
      ciudad:      'select[name*="city" i], select[name*="ciudad" i]',
    };

    const easySellRoot = () =>
      document.querySelector('form.es-form, #es-form') ||
      document.querySelector('#easysell-modal') ||
      document.querySelector('#es-form-container') ||
      (() => {
        const phone = document.querySelector(COD_FIELD_SELECTORS.celular);
        return phone ? phone.closest('form, [role="dialog"], section, div[class*="modal" i]') : null;
      })();

    const isVisible = (el) => {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      return rect.width > 50 && rect.height > 50 &&
             style.visibility !== 'hidden' && style.display !== 'none' &&
             parseFloat(style.opacity || '1') > 0.1;
    };

    const productData = window.ShopifyAnalytics?.meta?.product;
    const cartValue = productData?.variants?.[0]?.price ? productData.variants[0].price / 100 : null;
    const currency = window.Shopify?.currency?.active || 'USD';
    const productId = productData?.id ? String(productData.id) : null;

    const state = {
      tracked: false,
      submitted: false,
      openedAt: null,
      fieldsCompleted: [],
      lastFieldFocused: null,
      submitEventId: null,
    };

    window.__agCodLastCtaTrigger = null;
    let codObserver = null;

    function collectFieldState(root) {
      const filled = [];
      const missing = [];
      for (const [name, sel] of Object.entries(COD_FIELD_SELECTORS)) {
        const el = root.querySelector(sel);
        if (!el) continue;
        const v = (el.value || '').trim();
        if (v) filled.push(name);
        else if (el.required) missing.push(name);
      }
      return { filled, missing };
    }

    function attachFieldListeners(root) {
      Object.entries(COD_FIELD_SELECTORS).forEach(([name, sel]) => {
        const el = root.querySelector(sel);
        if (!el || el.dataset.phCodBound) return;
        el.dataset.phCodBound = '1';

        el.addEventListener('focus', () => {
          state.lastFieldFocused = name;
          posthog.capture('cod_field_focused', { field_name: name, page_path: pagePath });
        });

        el.addEventListener('blur', () => {
          const value = (el.value || '').trim();
          if (!value) return;
          const isValid = typeof el.checkValidity === 'function' ? el.checkValidity() : true;
          if (!state.fieldsCompleted.includes(name)) state.fieldsCompleted.push(name);

          posthog.capture('cod_field_completed', {
            field_name:   name,
            value_length: value.length,
            is_valid:     isValid,
            page_path:    pagePath,
          });

          if (!isValid) {
            posthog.capture('cod_field_invalid', {
              field_name: name,
              error_type: el.validationMessage || 'unknown',
              page_path:  pagePath,
            });
          }

          // Señal de alta intención: teléfono completo → Meta Lead
          if (name === 'celular' && isValid) {
            const eventId = genEventId();
            posthog.capture('cod_phone_captured', { meta_event_id: eventId });
            fbTrack('Lead', {
              content_ids:  productId ? [productId] : [],
              content_name: productData?.title,
              value:        cartValue,
              currency,
            }, eventId);
          }
        });

        if (el.tagName === 'SELECT') {
          el.addEventListener('change', () => {
            const value = el.value || el.options?.[el.selectedIndex]?.text;
            if (!value) return;
            const evt = name === 'provincia' ? 'cod_province_selected' :
                        name === 'ciudad'    ? 'cod_city_selected' : null;
            if (evt) posthog.capture(evt, { value, page_path: pagePath });
          });
        }
      });
    }

    function attachSubmitListener(root) {
      const candidates = Array.from(root.querySelectorAll('button, input[type="submit"]'));
      const submitBtn = candidates.find((b) => /toca aqui|comprar|ordenar|finalizar|enviar|pedir/i.test(
        (b.textContent || b.value || '').trim()
      ));
      if (!submitBtn || submitBtn.dataset.phCodBound) return;
      submitBtn.dataset.phCodBound = '1';

      submitBtn.addEventListener('click', () => {
        if (state.submitted) return;
        state.submitted = true;
        root.dataset.phSubmitted = '1';

        const eventId = genEventId();
        state.submitEventId = eventId;
        const fields = collectFieldState(root);

        posthog.capture('cod_submit_clicked', {
          cart_value:              cartValue,
          currency,
          fields_filled:           fields.filled,
          fields_missing:          fields.missing,
          field_completion_order:  state.fieldsCompleted,
          time_to_submit_ms:       Math.round(performance.now() - (state.openedAt || 0)),
          page_path:               pagePath,
          meta_event_id:           eventId,
        });

        // Custom event — NO Purchase. En COD el submit es un lead caliente; la
        // venta real ocurre cuando confirman por WhatsApp y se entrega.
        fbTrack('SubmitApplication', {
          content_ids:  productId ? [productId] : [],
          content_name: productData?.title,
          content_type: 'product',
          value:        cartValue,
          currency,
        }, eventId);
      }, true); // capture phase → antes del handler de EasySell (redirect)
    }

    function trackOpen(root) {
      if (state.tracked) return;
      state.tracked = true;
      if (codObserver) codObserver.disconnect();
      state.openedAt = performance.now();

      const eventId = genEventId();
      posthog.capture('cod_form_opened', {
        trigger_source:  window.__agCodLastCtaTrigger || 'unknown',
        page_template:   template,
        time_to_open_ms: Math.round(state.openedAt),
        meta_event_id:   eventId,
      });

      fbTrack('InitiateCheckout', {
        content_ids:  productId ? [productId] : [],
        content_name: productData?.title,
        num_items:    1,
        value:        cartValue,
        currency,
      }, eventId);

      attachFieldListeners(root);
      attachSubmitListener(root);
    }

    function probe() {
      const root = easySellRoot();
      if (!root) return;
      if (isVisible(root)) trackOpen(root);
      else attachFieldListeners(root);
    }

    let probeScheduled = false;
    function scheduleProbe() {
      if (probeScheduled) return;
      probeScheduled = true;
      requestAnimationFrame(() => { probeScheduled = false; probe(); });
    }
    function probeBurst() { [80, 250, 500, 900, 1500].forEach((ms) => setTimeout(probe, ms)); }

    // 1. Atribución del trigger que abre el form (incluye la oferta 3+1 sl-btn--offer)
    document.addEventListener('click', (e) => {
      const t = e.target.closest(
        '#StickyCtaBtn, [id^="es-"], [class*="es-sticky"], [class*="es-button"], ' +
        '.sl-sticky__cta, .sl-btn--offer, .sl-btn--full, .sl-btn, [data-srn-add], ' +
        '[onclick*="agTriggerEasySell"], [data-action*="checkout"], a[href*="/cart"]'
      );
      if (!t) return;
      const id = t.id || '';
      const cls = (t.className || '').toString();
      window.__agCodLastCtaTrigger =
        id === 'StickyCtaBtn'          ? 'sticky_cta' :
        /es-sticky/.test(cls)          ? 'easysell_sticky' :
        /sl-sticky__cta/.test(cls)     ? 'sticky_cta' :
        /sl-btn--offer/.test(cls)      ? 'offer_button' :
        /es-button|sl-btn/.test(cls)   ? 'inline_cta' :
                                         'cta_button';
      probeBurst();
    }, true);

    // 2. MutationObserver (form inyectado async / mostrado al abrir), rAF-debounced.
    idle(function () {
      codObserver = new MutationObserver(scheduleProbe);
      codObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden'],
      });
      probe();
    });

    // 3. Abandono al salir — solo si abrió el form, tocó algún campo y no envió.
    const fireAbandon = () => {
      if (!state.tracked || state.submitted) return;
      if (state.fieldsCompleted.length === 0) return;
      try {
        const payload = {
          event: 'cod_form_abandoned',
          fields_completed:   state.fieldsCompleted,
          last_field_focused: state.lastFieldFocused,
          time_in_form_ms:    Math.round(performance.now() - (state.openedAt || 0)),
          page_path:          pagePath,
        };
        posthog.capture('cod_form_abandoned', payload);
      } catch (e) {}
    };
    window.addEventListener('pagehide', fireAbandon);
  }

  // ══════════════════════════════════════════════════════════════════════════
  //  EVENTOS DE LANDING (sl-* / srn-*) — qué copy/imagen/objeción mueve la venta
  // ══════════════════════════════════════════════════════════════════════════

  // FAQ y dropdown de ingredientes son <details>; "toggle" no burbujea →
  // se escucha en capture a nivel de documento. Guard por selector: si la
  // página no tiene estos elementos, no dispara nada.
  document.addEventListener('toggle', function (e) {
    const el = e.target;
    if (!(el instanceof Element) || !el.open) return;

    if (el.matches('.sl-faq__item')) {
      posthog.capture('faq_opened', {
        faq_question: (el.querySelector('.sl-faq__q, summary')?.textContent || '').trim().slice(0, 140),
        faq_index:    Array.from(document.querySelectorAll('.sl-faq__item')).indexOf(el),
        page_path:    pagePath,
        page_template: template,
      });
    } else if (el.matches('.sl-dd__box')) {
      posthog.capture('ingredients_dropdown_opened', {
        label:     (el.querySelector('.sl-dd__sum, summary')?.textContent || '').trim().slice(0, 80),
        page_path: pagePath,
        page_template: template,
      });
    }
  }, true);

  // Oferta 3+1 — qué tier (1/2/3+1) clickea la gente. Los botones llevan
  // data-srn-qty (cantidad) y data-srn-add (variant id).
  document.addEventListener('click', function (e) {
    const offer = e.target.closest('.sl-btn--offer, [data-srn-qty], [data-srn-add]');
    if (!offer) return;
    posthog.capture('offer_selected', {
      offer_qty:    offer.dataset.srnQty ? parseInt(offer.dataset.srnQty, 10) : null,
      variant_id:   offer.dataset.srnAdd || null,
      offer_text:   (offer.textContent || '').trim().slice(0, 80),
      is_full:      offer.matches('.sl-btn--full'),
      page_path:    pagePath,
      page_template: template,
    });
  });

  // Galería — qué imagen del producto ve la gente (thumb/dot click + slide visible).
  document.addEventListener('click', function (e) {
    const nav = e.target.closest('.sl-gallery__thumb, .sl-gallery__dot');
    if (!nav) return;
    const isDot = nav.classList.contains('sl-gallery__dot');
    const items = Array.from(document.querySelectorAll(isDot ? '.sl-gallery__dot' : '.sl-gallery__thumb'));
    posthog.capture('gallery_image_viewed', {
      image_index:  items.indexOf(nav),
      via:          isDot ? 'dot_click' : 'thumb_click',
      page_path:    pagePath,
      page_template: template,
    });
  });

  // Botón "Toca para sonido" en videos de reseña — señal de intención alta (quiere oír el testimonio).
  document.addEventListener('click', function (e) {
    const sb = e.target.closest('[data-rv-sound]');
    if (!sb) return;
    const card = sb.closest('.srn-rv__vcard');
    const vid = card ? card.querySelector('.srn-rv__video') : null;
    const vName = vid ? (vid.getAttribute('poster') || vid.currentSrc || vid.src || '').split('?')[0].split('/').pop() : null;
    posthog.capture('review_sound_on', {
      video_name:    vName,
      page_path:     pagePath,
      page_template: template,
    });
  });

  const galleryImgs = document.querySelectorAll('.sl-gallery__img');
  if (galleryImgs.length) {
    const seenSlides = new Set();
    const galObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const imgs = Array.from(galleryImgs);
        const idx = imgs.indexOf(entry.target);
        if (seenSlides.has(idx)) return;
        seenSlides.add(idx);
        posthog.capture('gallery_image_viewed', {
          image_index:  idx,
          image_src:    (entry.target.currentSrc || entry.target.src || '').split('?')[0].split('/').pop(),
          via:          'slide_visible',
          page_path:    pagePath,
          page_template: template,
        });
      });
    }, { threshold: 0.6 });
    galleryImgs.forEach((img) => galObserver.observe(img));
  }

  // Videos (.srn-rv__video) — cuál se ve y hasta dónde (25/50/75/100%).
  const videos = document.querySelectorAll('.srn-rv__video, video');
  videos.forEach((video, vIndex) => {
    const vName = (video.getAttribute('poster') || video.currentSrc || video.src || `video_${vIndex}`)
      .split('?')[0].split('/').pop();
    const milestones = { 25: false, 50: false, 75: false, 100: false };
    let started = false;

    video.addEventListener('play', () => {
      if (started) return;
      started = true;
      posthog.capture('video_slide_viewed', {
        video_index: vIndex, video_name: vName, page_path: pagePath, page_template: template,
      });
    });

    video.addEventListener('timeupdate', () => {
      if (!video.duration) return;
      const pct = (video.currentTime / video.duration) * 100;
      [25, 50, 75, 100].forEach((m) => {
        if (pct >= m && !milestones[m]) {
          milestones[m] = true;
          posthog.capture('video_progress', {
            milestone: m, video_index: vIndex, video_name: vName,
            page_path: pagePath, page_template: template,
          });
        }
      });
    });
  });

  // Sticky CTA — cuándo aparece y cuándo lo clickean.
  const sticky = document.querySelector('.sl-sticky, .sl-sticky__cta');
  if (sticky) {
    let shown = false;
    const stObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !shown) {
          shown = true;
          posthog.capture('sticky_cta_shown', {
            time_to_show_ms: Math.round(performance.now()),
            page_path: pagePath, page_template: template,
          });
        }
      });
    }, { threshold: 0.1 });
    stObserver.observe(sticky);

    (document.querySelector('.sl-sticky__cta') || sticky).addEventListener('click', () => {
      posthog.capture('sticky_cta_clicked', { page_path: pagePath, page_template: template });
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  //  KPIs CRO — qué buscan primero y por qué se van
  // ══════════════════════════════════════════════════════════════════════════

  // first_content_engaged — 1er clic/tap real del usuario (qué mira/toca primero).
  let firstEngaged = false;
  function markFirstEngagement(e) {
    if (firstEngaged) return;
    firstEngaged = true;
    const el = e.target.closest('a, button, [role="button"], details summary, .sl-gallery__thumb, .srn-rv__video, img') || e.target;
    const section = nearestSection(el);
    posthog.capture('first_content_engaged', {
      target:        (el.tagName || '').toLowerCase(),
      target_text:   (el.textContent || el.getAttribute?.('aria-label') || '').trim().slice(0, 60) || null,
      section:       section ? sectionLabel(section) : null,
      time_ms:       Math.round(performance.now()),
      page_path:     pagePath,
      page_template: template,
    });
    document.removeEventListener('click', markFirstEngagement, true);
  }
  document.addEventListener('click', markFirstEngagement, true);

  // page_exit — al salir: hasta dónde llegó y si tocó los momentos clave.
  // Un solo disparo (pagehide). Responde "¿dónde/por qué se van?".
  const pageStart = performance.now();
  let exitFired = false;
  // 2026-09-26: el in-app browser de FB/IG se cierra sin 'pagehide' (48% de sesiones sin
  // page_exit). Se dispara también en visibilitychange=hidden y por sendBeacon.
  function firePageExit(trigger) {
    if (exitFired) return;
    exitFired = true;
    posthog.capture('page_exit', {
      exit_trigger:    trigger,
      max_scroll_pct:  maxScrollPct,
      last_section:    lastSectionInView,
      sections_viewed: viewedSections.size,
      reached_form:    !!document.querySelector('[data-ph-cod-bound], form.es-form, #es-form'),
      added_to_cart:   !!window.__agAddedToCart,
      time_on_page_ms: Math.round(performance.now() - pageStart),
      page_path:       pagePath,
      page_template:   template,
    }, { transport: 'sendBeacon' });
  }
  window.addEventListener('pagehide', function () { firePageExit('pagehide'); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') firePageExit('visibility_hidden');
  });

  // ══════════════════════════════════════════════════════════════════════════
  //  EXPERIMENTOS CRO — aplica variantes por feature flag de PostHog
  // ══════════════════════════════════════════════════════════════════════════
  // Los experimentos se DEFINEN en PostHog (feature flags con prefijo "cro_" +
  // un PAYLOAD por variante); el tema NO se toca por experimento. Payload de la
  // variante asignada = { pathname, ops: [{op, selector, value, target}] }.
  //   ops: text | html | hide | show | swapImg | move (reordenar).
  // Reversible: apagar el flag revierte (el DOM vuelve al original en el próximo
  // load). PostHog atribuye la conversión (cod_submit_clicked) por variante solo
  // — el flag viaja en TODOS los eventos capturados.
  // ⚠️ FOUC: corre tras cargar PostHog (idle) → hay un parpadeo en swaps ATF.
  // Mantener los swaps de texto above-the-fold mínimos, o pre-ocultar el bloque.
  function applyCroOps(ops) {
    (ops || []).forEach((o) => {
      try {
        document.querySelectorAll(o.selector).forEach((el) => {
          if (o.op === 'text') el.textContent = o.value;
          else if (o.op === 'html') el.innerHTML = o.value;
          else if (o.op === 'hide') el.style.setProperty('display', 'none', 'important');
          else if (o.op === 'show') el.style.removeProperty('display');
          else if (o.op === 'swapImg') { el.setAttribute('src', o.value); el.removeAttribute('srcset'); }
          else if (o.op === 'move' && o.target) { const t = document.querySelector(o.target); if (t) t.appendChild(el); }
        });
      } catch (e) {}
    });
  }
  // El callback recibe (flags, variants) YA cargados — usarlos directo es más
  // confiable que llamar getFlags() adentro (que puede estar vacío por timing).
  posthog.onFeatureFlags(function (flags, variants) {
    try {
      const list = (flags && flags.length) ? flags : ((posthog.featureFlags && posthog.featureFlags.getFlags && posthog.featureFlags.getFlags()) || []);
      list.filter((f) => f.indexOf('cro_') === 0).forEach((flag) => {
        const variant = (variants && variants[flag] != null) ? variants[flag] : posthog.getFeatureFlag(flag);
        if (!variant || variant === 'control' || variant === false) return;
        const payload = posthog.getFeatureFlagPayload(flag);
        if (!payload || !payload.ops) return;
        if (payload.pathname && pagePath.indexOf(payload.pathname) !== 0) return;
        applyCroOps(payload.ops);
      });
    } catch (e) {}
  });

})();
